// icons
import Car from 'assets/images/career/icons/car.svg';
import Globe from 'assets/images/career/icons/globe.svg';
import Resize from 'assets/images/career/icons/resize.svg';
import Chain from 'assets/images/career/icons/chain.svg';
import Battery from 'assets/images/career/icons/battery.svg';
import Smile from 'assets/images/career/icons/smile.svg';
import Cookie from 'assets/images/career/icons/cookie.svg';
import Reload from 'assets/images/career/icons/reload.svg';
import Source from 'assets/images/career/icons/source.svg';
import Circles from 'assets/images/career/icons/circles.svg';
import Undo from 'assets/images/career/icons/undo.svg';
import Ball from 'assets/images/career/icons/ball.svg';
import Clock from 'assets/images/career/icons/clock.svg';
import Star from 'assets/images/career/icons/star.svg';

export const dataOpportunities = [
  {
    id: 1,
    icon: Globe,
    title: 'Ambitious international projects. ',
    text:
      'Clients that match our mindset; no lame products or old technologies',
  },
  {
    id: 2,
    icon: Resize,
    title: 'Budget for conferences & growth. ',
    text: '3000 PLN net per year + 5 days off',
  },
  {
    id: 3,
    icon: Chain,
    title: 'Individual career path. ',
    text: 'Tech mentoring, coaching, career planning, constant feedback',
  },
  {
    id: 4,
    icon: Battery,
    title: 'Open events and meetups. ',
    text: 'Front Club, Dribbble Meetup, Holacracy Practitioners',
  },
  {
    id: 5,
    icon: Smile,
    title: 'Wellbeing Satisfaction. ',
    text: 'Guide support, yoga and mindfulness exercises',
  },
  {
    id: 6,
    icon: Reload,
    title: 'Scrum and Lean Startup Approach. ',
    text: 'Modern project management methodologies',
  },
  {
    id: 7,
    icon: Source,
    title: 'Open Source and R&D projects ',
    text: 'e.g. Marble.js, Machine Learning Chapter, PHP slang, WTF Framework',
  },
  {
    id: 8,
    icon: Circles,
    title: 'Holacracy. ',
    text:
      'There’s no managers and we decide all together about company issues',
  },
];

export const dataBenefits = [
  {
    id: 1,
    icon: Undo,
    title: 'Agile Office. ',
    text: 'Super comfy office we designed ourselves',
  },
  {
    id: 2,
    icon: Ball,
    title: 'Chillout spaces. ',
    text: 'Cafe, silence room, chaos room, cinema',
  },
  {
    id: 3,
    icon: Clock,
    title: 'Flexible work conditions. ',
    text:
      'Variety of cooperation forms, flexible working hours, partially remote work',
  },
  {
    id: 4,
    icon: Cookie,
    title: 'Fruits & food. ',
    text: 'Weekly lunches, fresh fruits, coffee and snacks',
  },
  {
    id: 5,
    icon: Star,
    title: 'Benefit platform. ',
    text: 'Multisport, medicover, english lessons & more',
  },
  {
    id: 6,
    icon: Car,
    title: 'Free parking lot ',
    text: '(only applies to Gliwice)',
  },
];
